import axios from 'axios';
import { shared } from '../config';

export const digHttp = axios.create({
  baseURL: shared.DIG_URL,
  headers: {
    'Content-Type': 'application/json',
    dig_token: shared.DIG_TOKEN,
  },
  validateStatus: status => status >= 200 && status < 300,
});

export const http = axios.create({
  baseURL: '',
  validateStatus: status => status >= 200 && status < 300,
});
